import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "../globals";
import { axiosInstance } from "../services/v2/axiosInstance";

/*
	Catálogo e Inventario viejos cerrados por plantel (Honduras desde 2026-10-31). Desde Módulos Claros (2026-11-01) la lista
	NO está escrita aquí: la manda el backend (GET /api/v2/catalog/catalogoViejoCerrado, que lee CATALOGO_VIEJO_CERRADO del
	.env del servidor). Cerrar MTY y TRC = cambiar ese valor en el servidor; la app lo toma al recargar, sin publicar nada.
	Mientras llega la respuesta (o si falla) vale lo de siempre: Honduras cerrado (3, 4, 5, 6), México abierto.
	El backend también rechaza el cargo y el guardado (Constants::catalogoViejoCerrado).
*/
export const PLANTELES_CATALOGO_CERRADO_POR_OMISION: number[] = [3, 4, 5, 6];
export const SECCIONES_CATALOGO_VIEJO: string[] = ["store", "inventory"];

let cerrados: number[] = PLANTELES_CATALOGO_CERRADO_POR_OMISION;
let pedido: Promise<void> | null = null;
const avisar = new Set<() => void>();

const cargar = (): Promise<void> => {
	if (!pedido) {
		pedido = axiosInstance.get("/catalog/catalogoViejoCerrado")
			.then((response) => {
				const ids = response?.data?.campusIds;
				if (Array.isArray(ids)) {
					cerrados = ids.map(Number).filter((id) => id > 0);
					avisar.forEach((fn) => fn());
				}
			})
			// Sin respuesta se queda lo de siempre y se vuelve a pedir en el próximo inicio de sesión / recarga.
			.catch(() => { pedido = null; });
	}
	return pedido;
};

/** Pide la lista al backend (una vez por carga de la app) y vuelve a pintar a quien la usa cuando llega. */
export const usePlantelesCatalogoCerrado = (sesionLista: boolean = true): number[] => {
	const [, setVuelta] = useState<number>(0);
	useEffect(() => {
		const fn = () => setVuelta((n) => n + 1);
		avisar.add(fn);
		return () => { avisar.delete(fn); };
	}, []);
	useEffect(() => { if (sesionLista) cargar(); }, [sesionLista]);
	return cerrados;
};

export const catalogoViejoCerrado = (campusId?: number | null): boolean => !!campusId && cerrados.includes(Number(campusId));

/** El menú del plantel escogido: donde está cerrado, sin Catálogo ni Inventario (y sin grupos que se queden vacíos). */
export const menuDelPlantel = (menu: any[], campusId?: number | null): any[] => !catalogoViejoCerrado(campusId) ? menu
	: menu.map((block: any) => ({ ...block, sections: (block.sections || []).filter((section: any) => !SECCIONES_CATALOGO_VIEJO.includes(section.route)) }))
		.filter((block: any) => block.sections.length > 0);

const Cerrado: React.FC = () => {
	const navigate = useNavigate();
	const currentUser: any = useSelector((state: RootState) => state.userProfile.value);
	// Sin importar common.tsx (que importa este archivo): bit Navegar (1) de Nueva Venta en el rol actual (la ruta abre Ventas).
	const puedeVender = currentUser?.currentRole === "superAdmin" || ((currentUser?.roleMap?.[currentUser?.currentRole]?.permits?.newSale?.binary_quintet_RCUDN_permissions || 0) & 9) === 9;
	return <div style={{ padding: "48px 24px", display: "flex", justifyContent: "center" }}>
		<div style={{ maxWidth: "460px", textAlign: "center", background: "var(--wa-superficie)", border: "1px solid var(--wa-filo)", borderRadius: "12px", padding: "28px 24px" }}>
			<div style={{ fontSize: "22px", fontWeight: 700 }}>Catálogo Viejo Cerrado</div>
			<div style={{ fontSize: "14px", color: "var(--wa-apagado)", margin: "8px 0 18px" }}>Carga los productos desde Ventas o desde el Estado de Cuenta del alumno.</div>
			{puedeVender ? <button type="button" className="btn btn-primary rounded-pill" onClick={() => navigate("/newSale?nueva=1")}>Ir a Nueva Venta</button> : null}
		</div>
	</div>;
};

/** La pantalla vieja (Catálogo o Inventario) solo abre donde no está cerrada. */
export const conCatalogoAbierto = (Pantalla: React.ComponentType<any>): React.FC<any> => {
	const ConCandado: React.FC<any> = (props: any) => {
		const campusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
		usePlantelesCatalogoCerrado();
		return catalogoViejoCerrado(campusId) ? <Cerrado /> : <Pantalla {...props} />;
	};
	return ConCandado;
};
